import { render, staticRenderFns } from "./r-currency-kind-dropdown.vue?vue&type=template&id=4c648c3a"
import script from "./r-currency-kind-dropdown.vue?vue&type=script&lang=js"
export * from "./r-currency-kind-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c648c3a')) {
      api.createRecord('4c648c3a', component.options)
    } else {
      api.reload('4c648c3a', component.options)
    }
    module.hot.accept("./r-currency-kind-dropdown.vue?vue&type=template&id=4c648c3a", function () {
      api.rerender('4c648c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency-kind/r-currency-kind-dropdown.vue"
export default component.exports